
import { useStatsData } from './hooks/useStatsData';
import { useCardReordering } from './hooks/useCardReordering';
import { StatCardData } from './types';
import { useCardVisibility } from './hooks/useCardVisibility';

export const useStatsCardData = () => {
  // Get stat card data and state management from custom hook
  const { statCards, setStatCards, deviceDataLoading, addStatCard, updateStatCard, removeStatCard } = useStatsData();
  
  // Get card reordering functionality from custom hook
  const { handleReorderStatCards, validateDragOperation } = useCardReordering(statCards, setStatCards);
  
  // Get card visibility management functionality
  const { toggleCardVisibility, hiddenCards } = useCardVisibility(statCards, setStatCards);

  return {
    statCards,
    setStatCards,
    deviceDataLoading,
    handleReorderStatCards,
    validateDragOperation,
    toggleCardVisibility,
    hiddenCards,
    addStatCard,
    updateStatCard,
    removeStatCard
  };
};

// Re-export for backward compatibility
export type { StatCardData };
